import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/phase_groups',
    name: 'PhaseGroup',
    component: {
      name: 'AdminPhaseGroup',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'phase_group',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminPhaseGroupIndex',
        component: () => import('../views/PhaseGroupIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminPhaseGroupNew',
        component: () => import('../views/PhaseGroupInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminPhaseGroupIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminPhaseGroupShow',
        component: () => import('../views/PhaseGroupShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminPhaseGroupIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminPhaseGroupDetails',
            component: () => import('../views/PhaseGroupDetails.vue'),
            meta: {
              backRoute: { name: 'AdminPhaseGroupIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminPhaseGroupEdit',
            component: () => import('../views/PhaseGroupInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminPhaseGroupDetails' },
            },
          },
          {
            path: 'phases/new',
            name: 'AdminPhaseGroupPhaseNew',
            component: () => import('../views/phase/PhaseInput.vue'),
            meta: {
              action: 'new',
              resource: 'phase',
              customName: 'views.phase_group.new_phase',
              backRoute: { name: 'AdminPhaseGroupDetails' },
            },
          },
          {
            path: 'phases/:phaseId(\\d+)/edit',
            name: 'AdminPhaseGroupPhaseEdit',
            component: () => import('../views/phase/PhaseInput.vue'),
            meta: {
              action: 'edit',
              resource: 'phase',
              customName: 'views.phase_group.edit_phase',
              backRoute: {
                name: 'AdminPhaseGroupIndex',
              },
              tArgs: route => ({ name: route?.params?.phaseId }),
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));